"use client";
import { env } from "@/env/client";
import { authClient } from "@/lib/authClient";
import { setSearchInsightsAllowed } from "@/lib/searchInsightsConsent";
import {
  ITM_UID_COOKIE,
  deleteClientTrackingCookie,
  getOrCreateClientTrackingId,
  watchConsentCategory,
} from "privacy-consent";
import { useEffect, useRef } from "react";
import searchInsights from "search-insights";

export function SearchInsights() {
  const { data, isPending } = authClient.useSession();
  const isInitializedRef = useRef(false);

  useEffect(() => {
    return watchConsentCategory("2", (allowed) => {
      setSearchInsightsAllowed(allowed);

      if (!allowed) {
        deleteClientTrackingCookie(ITM_UID_COOKIE);
        if (isInitializedRef.current) {
          searchInsights("setAuthenticatedUserToken", undefined);
        }
        return;
      }

      const userToken = getOrCreateClientTrackingId(ITM_UID_COOKIE);

      searchInsights("init", {
        appId: env.algoliaAppId,
        apiKey: env.algoliaSearchApiKey,
        userToken,
      });

      isInitializedRef.current = true;
    });
  }, []);

  useEffect(() => {
    if (isPending) return;

    return watchConsentCategory("2", (allowed) => {
      if (!isInitializedRef.current) return;
      searchInsights("setAuthenticatedUserToken", allowed ? data?.user.id : undefined);
    });
  }, [data, isPending]);

  useEffect(() => {
    if (isPending) return;

    return watchConsentCategory("2", (allowed) => {
      window._paq = window._paq || [];

      if (allowed && data?.user.id) {
        window._paq.push(["setUser", data.user.id]);
      } else {
        window._paq.push(["deleteUser"]);
      }
    });
  }, [data, isPending]);

  return null;
}
